module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step1_Image14.deb97ec4.jpg";